import React, { useEffect, useState } from 'react';

import { Formik } from 'formik';
import * as Yup from 'yup';

import ModalFooter from 'CommonComponents/ModalFooter';
import SelectFromField from 'CommonComponents/SelectFromField';
import TextFormField from 'CommonComponents/TextFormField';

import { useToast } from 'Hooks/useToast';

const SuppliersCreateSchema = Yup.object().shape({
    supplierName: Yup.string().required($t('This value is required')),
    supplierCode: Yup.string().required($t('This value is required')),
    contactName: Yup.string().required($t('This value is required')),
    contactEmail: Yup.string().email($t('Invalid email')).required($t('This value is required')),
    location: Yup.string(),
    postCode: Yup.string(),
});

export default function SuppliersEditForm(props) {
    const [locations, setLocations] = useState([]);
    const toast = useToast();

    useEffect(() => {
        fetchLocations();
    }, []);

    const fetchLocations = () => {
        axios
            .get(props.suppliersCreateUrl)
            .then((response) => {
                setLocations(response.data.locations);
            })
            .catch((e) => {
                console.log(e.response);
            });
    };

    return (
        <Formik
            initialValues={{
                supplierName: props.supplier?.name ?? '',
                supplierCode: props.supplier?.code ?? '',
                contactName: props.supplier?.supplier_contact?.name ?? '',
                contactEmail: props.supplier?.supplier_contact?.email ?? '',
                location: props.supplier?.location ?? '',
                postCode: props.supplier?.post_code ?? '',
            }}
            validationSchema={SuppliersCreateSchema}
            onSubmit={(values, actions) => {
                axios
                    .put(props.suppliersUpdateUrl.replace('SUPPLIER_ID', props.supplier.id), values)
                    .then((response) => {
                        props.setSupplierIsUpdated(true);
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                        toast.error(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Supplier Name')}
                            required={true}
                            type="text"
                            name="supplierName"
                            placeholder={$t('Supplier Name')}
                        ></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Supplier Code')}
                            required={true}
                            type="text"
                            name="supplierCode"
                            placeholder={$t('Supplier Code')}
                        ></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Contact Name')}
                            required={true}
                            type="text"
                            name="contactName"
                            placeholder={$t('Contact Name')}
                        ></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField
                            label={$t('Contact Email')}
                            required={true}
                            type="text"
                            name="contactEmail"
                            placeholder={$t('Contact Email')}
                        ></TextFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <SelectFromField label={$t('Country')} as="select" name="location">
                            <option value={''}>{$t('Select Country')}</option>
                            {locations.map((location) => {
                                return (
                                    <option key={location.isoCodeAlpha2} value={location.isoCodeAlpha2}>
                                        {location.name}
                                    </option>
                                );
                            })}
                        </SelectFromField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('PostCode')} type="text" name="postCode" placeholder={$t('Post Code')}></TextFormField>
                    </div>

                    <ModalFooter
                        cancelButtonText={$t('Cancel')}
                        primaryButtonText={$t('Update')}
                        onCancel={props.internalCloseHandler}
                        handleSubmit={handleSubmit}
                        isSubmitting={props.request}
                    ></ModalFooter>
                </>
            )}
        </Formik>
    );
}
